import React from 'react'
import { useAppSelector } from '@SonarCX/hooks/redux'

import NoDocuments from '../NoDocuments'
import ArticleView from '../ArticleView'
import DocumentTableView from '../DocumentTableView'

import { selectArticles } from '@SonarCX/slices/article'

const Content: React.FC = () => {
  const { root, creating, selected, articles } = useAppSelector(selectArticles)

  // No documents in the system
  if (!root) {
    return <NoDocuments />
  }

  // Creating a new article
  if (creating) {
    return <ArticleView />
  }

  // Default view
  if (!selected || !articles[selected]) {
    return <DocumentTableView />
  }

  // Viewing an article
  if (articles[selected].type === 'article') {
    return <ArticleView />
  }

  // No documents in the folder
  if (articles[selected].items.length === 0) {
    return <NoDocuments onSubFolder />
  }

  return <DocumentTableView />
}

export default Content
